import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useStore from '../postulation_form/store/useStore';

export const useRouter = () => {
  // Detect Route Change with react-router
  const location = useLocation();
  const { currentStep, setCurrentStep } = useStore();
  useEffect(() => {
    const step = parseInt(location.hash.slice(-1), 10);
    if (currentStep !== step) {
      setCurrentStep(step || 1);
    }
  }, [location]);
};
